import { instance } from "..";

// Public plan catalog (prices from server config).
export const getPlans = async () => {
  const { data } = await instance.get("/api/payments/plans");
  return data; // { currency, configured, plans:[{plan, months, durationDays, price}] }
};

// Creates a MyFatoorah hosted payment. Returns { invoiceId, paymentUrl }.
// With a discount `code` the server charges the discounted amount (it
// rejects the request if the code doesn't apply to this plan / account).
export const createInvoice = async (plan, code) => {
  const { data } = await instance.post(
    "/api/payments/myfatoorah/create-invoice",
    code ? { plan, code } : { plan },
  );
  return data;
};

// What a discount code is worth for the signed-in account, per plan.
// Returns { valid, message?, code, plans:[{plan, applies, originalAmount,
// discountAmount, finalAmount}] }.
export const previewDiscount = async (code) => {
  const { data } = await instance.post("/api/payments/discount/preview", {
    code,
  });
  return data;
};

// Public (no login): what a code is worth before sign-in. Only rules about
// the code itself; `needsAccountCheck` means signing in may still turn it
// down. A code for named accounts comes back without `plans`.
export const checkDiscount = async (code) => {
  const { data } = await instance.post("/api/payments/discount/check", {
    code,
  });
  return data;
};

// Owner-only; reconciles with MyFatoorah. Returns { status, paid }.
export const getInvoiceStatus = async (invoiceId) => {
  const { data } = await instance.get(
    `/api/payments/myfatoorah/status/${invoiceId}`,
  );
  return data;
};

// Fallback when localStorage lost the invoiceId: MyFatoorah appends
// ?paymentId= to the callback URL. Owner-only. Returns { invoiceId, status, paid }.
export const getInvoiceStatusByPayment = async (paymentId) => {
  const { data } = await instance.get(
    `/api/payments/myfatoorah/status/by-payment/${encodeURIComponent(paymentId)}`,
  );
  return data;
};
